import {
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import { Fragment, useState } from "react";
import { useRefresh, useNotify, useMutation, Button } from "react-admin";
import SaveIcon from "@material-ui/icons/Save";

interface IInactiveStudentButton {
  studentId: string;
}

const CustomConfirmButton = ({ studentId }: IInactiveStudentButton) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const [handleChangeStatusStudent, { loading }] = useMutation(
    {
      type: "customUpdate",
      resource: `students/${studentId}/inactive`,
      payload: {},
    },
    {
      onSuccess: ({ data }) => {
        notify(
          `Successfully inactive student. Make sure to update the Student Schedules.`,
          "info"
        );
        refresh();
      },
      onFailure: (error) =>
        notify(
          `Failed inactive the student, error: ${error.message}`,
          "warning"
        ),
    }
  );

  return (
    <Button
      onClick={handleChangeStatusStudent}
      color="primary"
      label={loading ? "Please wait..." : "Confirm"}
      autoFocus
    >
      <SaveIcon />
    </Button>
  );
};

const InactiveStudentButton = ({ studentId }: IInactiveStudentButton) => {
  const [open, setOpen] = useState<boolean>(false);

  const useStyles = makeStyles({
    dialog: {
      "& .MuiDialog-paper": {
        overflowY: "unset",
      },
    },
    table: {
      marginTop: "10px",
      minWidth: 650,
      padding: "1rem",
    },
  });

  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <Button
        label={`Terminate Student`}
        onClick={handleOpenDialog}
        style={{ backgroundColor: "#f44336" }}
      />
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">Terminate The Student</DialogTitle>
        <DialogContent>
          <DialogContentText color="initial">
            Are you sure to Terminate the student ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Back" />
          <CustomConfirmButton studentId={studentId} />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default InactiveStudentButton;
